import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  rating: number;
  views: number;
  tags: string[];
  status: string;
}

export default function ComicCard({
  id,
  title,
  author,
  cover,
  category,
  rating,
  views,
  tags,
  status,
}: ComicCardProps) {
  const categoryName = categories.find((c) => c.slug === category)?.name || category;

  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/comic/${id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
      data-product-shop
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={cover}
          alt={`${title} - 韩漫在线观看`}
          title={`${title} - 韩漫之家免费下拉式漫画`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-md">
            {categoryName}
          </span>
        </div>
        {status === 'ongoing' && (
          <div className="absolute top-2 right-2">
            <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-md">
              连载中
            </span>
          </div>
        )}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-2 text-background-50 text-xs">
            <div className="flex items-center gap-1">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
              <span>{rating}</span>
            </div>
            <div className="flex items-center gap-1">
              <i className="ri-eye-line text-xs"></i>
              <span>{formatViews(views)}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-500 transition-colors duration-200">
          {title}
        </h3>
        <p className="text-xs text-foreground-600 mt-1">{author}</p>
        <div className="flex flex-wrap gap-1 mt-2">
          {tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-1.5 py-0.5 bg-background-100 text-foreground-600 text-xs rounded"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}